import React from 'react';
import type IconName from '@upsales/components/Icon/IconName';
import { Flex, Icon, Text } from '@upsales/components';
import BemClass from '@upsales/components/Utils/bemClass';

import './Suggestion.scss';

type SuggestionProps = {
	icon?: IconName;
	title: string;
	fullWidth?: boolean;
	onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
};

const Suggestion = ({ icon, title, onClick, fullWidth = true }: SuggestionProps) => {
	const classes = new BemClass('Suggestion');

	return (
		<Flex alignItems="center" gap="u2" className={classes.mod({ fullWidth }).b()} space="pll prl" onClick={onClick}>
			{icon ? <Icon name={icon} /> : null}
			<Text size="sm">{title}</Text>
		</Flex>
	);
};

export default Suggestion;
